module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<form class=\"form-group\"> <div class=\"input-group input-group-sm has-feedback-left\"> <input type=\"text\" class=\"form-control\" placeholder=\"")
    ; __append(escapeFn( locals.placeholder ))
    ; __append("\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span> <span class=\"input-group-btn\"> <button class=\"btn btn-blue\" type=\"submit\">Search</button> </span> </div> </form> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/list/search/template.ejs
// module id = 793
// module chunks = 1